export const KEY_HIDE_MODAL_CONFIRM_REMOVE_FROM_FAVORITES = 'doNotShowModalRemoveFromFavorites';
